import type { Currencies, Currency } from '@patrianna/shared-patrianna-types/store/CurrenciesModule'
import { createSelector } from '@reduxjs/toolkit'

import type { ReduxState } from 'src/store/types'

const getCurrencies = (state: ReduxState) => state.currencies

export const getActiveCurrencyIdSelector = createSelector(getCurrencies, (currencies) => currencies.activeCurrencyId)
export const getActiveModalCurrencyIdSelector = createSelector(
  getCurrencies,
  (currencies) => currencies.activeModalCurrencyId,
)
export const getAllCurrenciesSelector = createSelector(getCurrencies, (currencies) => currencies.allCurrencies)
export const isCurrenciesAvailableSelector = createSelector(getCurrencies, (currencies) =>
  Boolean(currencies.allCurrencies?.length),
)

export const getSweepstakeCurrencySelector = createSelector(getAllCurrenciesSelector, (allCurrencies) =>
  allCurrencies.find((i) => i.currency === 'SC'),
)

export const getGoldCurrencySelector = createSelector(getAllCurrenciesSelector, (allCurrencies) =>
  allCurrencies.find((i) => i.currency === 'GC'),
)

export const isSweepstakeCurrencyActiveSelector = createSelector(getActiveCurrencyIdSelector, (id) => id === 'SC')

export const getCurrencyInitializedSelector = createSelector(
  getActiveCurrencyIdSelector,
  (activeCurrencyId) => activeCurrencyId !== null,
)

export const getBalanceByIDSelector = createSelector(
  getAllCurrenciesSelector,
  (_: ReduxState, currencyId: Currencies) => currencyId,
  (allCurrencies, currencId) => allCurrencies.find((el) => el.currency === currencId),
)

export const getCurrentBalanceSelector = createSelector(
  getAllCurrenciesSelector,
  getActiveCurrencyIdSelector,
  (allCurrencies, activeCurrency) => {
    return allCurrencies.find((i: Currency) => i.currency === activeCurrency)
  },
)
